// extracted by mini-css-extract-plugin
export default {"priority":"PriorityGridCell_priority__MLbGC","prioritySelect":"PriorityGridCell_prioritySelect__UUYYl"};